import { Typography } from '@material-ui/core'
import { Stack } from 'components'
import { useNavigate } from 'react-router-dom'
import { useStyles } from './styles/header'

export const Header = ({ children, title }) => {
  const classes = useStyles()
  const navigate = useNavigate()

  return (
    <Stack
      className={classes.default}
      justify="space-between"
      items="center"
      flex="1"
      wrap="wrap"
    >
      <Stack
        className={classes.header}
        direction="row"
        items="center"
        spacing="6"
      >
        <Typography
          variant="h3"
          className={classes.title}
          onClick={() => navigate('/')}
        >
          {title}
        </Typography>
      </Stack>

      <div>{children}</div>
    </Stack>
  )
}

export default Header
